/**
 * Agencies and employers (JT1-1855). The API records JobTetris's tenant type on the org's settings
 * at sign-in: 'recruiter' (agency) or 'client' (employer). Employers aren't offered the campaign
 * types built on agency work. Unknown means an org not seen since this was added: treated as an
 * agency, and the API has the final say.
 */
const AGENCY_ONLY_CAMPAIGN_TYPES: readonly string[] = ['BD', 'DEAL'];

export function availableToOrg(campaignType: string, jtOrgType: string | null | undefined): boolean {
  return jtOrgType !== 'client' || !AGENCY_ONLY_CAMPAIGN_TYPES.includes(campaignType);
}
